import   React                             ,
       { useState                          ,
	     useEffect                         }  from 'react';

import   classNames                           from 'classnames';

import   styles                               from './AdsCampaignSheet.module.scss';
  
import   Field                                from '../../widget/inputs/Field';
import   FieldCalendar                        from '../../widget/inputs/FieldCalendar';
import   FieldLegalStructure                  from '../../widget/inputs/FieldLegalStructure';
import   Select                               from '../../widget/inputs/Select';
import   Trigger                              from '../../widget/actuators/Trigger';
import   WidgetFrame                          from '../../widget/navigation/WidgetFrame';
import   Window                               from '../../widget/windows/window';

import { AdSpot                            ,
         initializedAdSpot                 }  from '../../../dataTypes/mediaManagment/adSpot_types';

import { LegalStructure                    ,
         initializedLegalStructure         }  from '../../../dataTypes/legalStructureManagment/types';
		 
import { Media                     }  from '../../../dataTypes/mediaManagment/types';
		 
		 

import { AdsCampaign                       ,
         initializedAdsCampaign            }  from '../../../dataTypes/adsCampaignManagment/types';
		 
import { compareAdsCampaign                }  from '../../../dataTypes/adsCampaignManagment/utils';


import { convertStringToDate               ,
         convertDateToString             }  from '../../../dataTypes/timeManagment/utils';
		 
import { createAdsCampaign                 ,
         updateAdsCampaign                 }  from '../../../backendServices/adsCampaignManagment/api_adsCampaign';

import   AdSpotSelector                           from './AdSpotSelector';
import   LegalStructureSelector               from '../legalStructureManagment/LegalStructureSelector';
 		 
export interface AdsCampaignSheetProps {
  legalStructures        : LegalStructure[]    ;
  existingAdsCampaigns   : AdsCampaign []      ; 
  adsCampaign?           : AdsCampaign         ;
  onCreate?              : (id:number) => void ;
  onEdit?                : (id:number) => void ;
}

export const AdsCampaignSheet = ({ legalStructures      ,
                                   existingAdsCampaigns ,
                                   adsCampaign          ,
                                   onCreate             ,
                                   onEdit               }: AdsCampaignSheetProps) => {

  const isEditMode = adsCampaign !== undefined;

  const initialAdsCampaign: AdsCampaign = isEditMode ? adsCampaign! : initializedAdsCampaign();

  const [ adSpotSet                           ] = useState<AdSpot[]> ( [] );

  const [ id                                  ] = useState ( initialAdsCampaign.id                           );
  const [ creationDate                        ] = useState ( initialAdsCampaign.creationDate                 );
  const [ reference                           , setReference                           ] = useState ( initialAdsCampaign.reference                    );
  const [ agentId                             , setAgentId                             ] = useState ( initialAdsCampaign.agentId                      );
  const [ totalPriceWithoutTax                , setTotalPriceWithoutTax                ] = useState ( initialAdsCampaign.totalPriceWithoutTax         );
  const [ totalPriceWithTax                   , setTotalPriceWithTax                   ] = useState ( initialAdsCampaign.totalPriceWithTax            );
  const [ taxRate                             , setTaxRate                             ] = useState ( initialAdsCampaign.taxRate                      );
  const [ legalStructureId                    ] = useState ( initialAdsCampaign.legalStructureId             );
  const [ beginningDate                       , setBeginningDate                       ] = useState ( initialAdsCampaign.beginningDate                );
  const [ endingDate                          , setEndingDate                          ] = useState ( initialAdsCampaign.endingDate                   );
  const [ name                                , setName                                ] = useState ( initialAdsCampaign.name                         );
  const [ channelId                           , setChannelId                           ] = useState ( initialAdsCampaign.channelId                    );
  const [ areaId                              , setAreaId                              ] = useState ( initialAdsCampaign.areaId                       );
  const [ advertisingSpotsNumberPerDay        , setAdvertisingSpotsNumberPerDay        ] = useState ( initialAdsCampaign.advertisingSpotsNumberPerDay );
  const [ spotDuration                        , setSpotDuration                        ] = useState ( initialAdsCampaign.spotDuration                 );
  const [ advertisingSpotsNumber              ] = useState (0)//( initialAdsCampaign.advertisingSpotsNumber       );
  const [ spotPriceWithoutTax                 ] = useState (0)//( initialAdsCampaign.spotPrice                    );
  const [ spotPriceWithTax                    ] = useState (0)//( initialAdsCampaign.spotPrice                    );
  const [ adSpotId                            ] = useState ( initialAdsCampaign.adSpotId                     );
  const [ schedule                            ] = useState ( initialAdsCampaign.schedule                     );

  const [ referenceMessage                    ] = useState ( '' );
  const [ agentIdMessage                      ] = useState ( '' );
  const [ totalPriceWithoutTaxMessage         ] = useState ( '' );
  const [ totalPriceWithTaxMessage            ] = useState ( '' );
  const [ taxRateMessage                      ] = useState ( '' );
  const [ legalStructureIdMessage             , setLegalStructureIdMessage             ] = useState ( '' );
  const [ beginningDateMessage                , setBeginningDateMessage                ] = useState ( '' );
  const [ endingDateMessage                   , setEndingDateMessage                   ] = useState ( '' );
  const [ nameMessage                         , setNameMessage                         ] = useState ( '' );
  const [ channelIdMessage                    ] = useState ( '' );
  const [ areaIdMessage                       ] = useState ( '' );
  const [ advertisingSpotsNumberPerDayMessage ] = useState ( '' );
  const [ spotDurationMessage                 ] = useState ( '' );
  const [ mediaIdMessage                      ] = useState ( '' );

  const [ fieldsAreModified                   , setFieldsAreModified                   ] = useState ( false );

  const [ saved                      , setSaved                      ] = useState ( false );
  const [ cancelation                , setCancelation                ] = useState ( false );

  let adsCampaignSheetId:number = 0

  const [ checkError                 , setCheckError                 ] = useState ( false );
  const [           , setShowErrorMessages          ] = useState ( false );
  const [ apiError                   , setApiError                   ] = useState ( false );

  const [ progress                   , setProgress                   ] = useState ( 0 );

  const [ saveButtonLock             , setSaveButtonLock             ] = useState ( false )


  const getChoosenLegalStructure = (id: number): LegalStructure => {

    if (!legalStructures || legalStructures.length === 0)
	 {
      console.warn('getChoosenLegalStructure: legalStructure array is empty or not provided.');
      return initializedLegalStructure();
     }

    for (let i = 0; i < legalStructures.length; i++)
	 {
      if (legalStructures[i].id == id)
	   {
        return legalStructures[i];
       }
     }

    console.warn('getChoosenLegalStructure: legalStructure not found, returning initializedLegalStructure.');
    return initializedLegalStructure();
  };

  const getChoosenAdSpot = (id: number): AdSpot => {
/*
    if (!medias || medias.length === 0)
	 {
      console.warn('getChoosenMedia: videos array is empty or not provided.');
      return initializedMedia();
     }

    for (let i = 0; i < medias.length; i++)
	 {
      if (medias[i].id == id)
	   {
        return medias[i];
       }
     }
*/
    console.warn('getChoosenAdSpot: adSpot not found, returning initializedAdSpot.');
    return initializedAdSpot();
  };

  const [ choosenLegalStructure      , setChoosenLegalStructure      ] = useState<LegalStructure>(isEditMode ? getChoosenLegalStructure(legalStructureId) : initializedLegalStructure());
  const [ legalStructureSelection    , setLegalStructureSelection    ] = useState(false);
  const [ choosenAdSpot              ] = useState<Media>(isEditMode ? getChoosenAdSpot(adSpotId) : initializedAdSpot());
  const [ adSpotSelection            , setAdSpotSelection            ] = useState(false);

  const testLegalStructure  = ( legalStructureId : number ) : string => {

	if ( legalStructureId === 0)
	      {
	       return ("Il manque l'entreprise") 
	      }
	 else {
	       return ("") 
	      }
  }



  const handleLegalStructureSelectorHide = () => {
    setLegalStructureSelection(false);
  }

  const handleAdSpotSelectorShow = () => {
    setAdSpotSelection(true);
  }

  const handleAdSpotSelectorHide = () => {
    setAdSpotSelection(false);
  }

  const renderChoosenAdSpot = (): JSX.Element => {

    return (
      <div className={classNames(styles.centeredElements)} >

		  {/*  <VideoPlayerWithAdvertisingSupport video={choosenAdSpot as AdSpot} /> */}
        <div className={classNames(styles.line_2, styles.text)}>
          {choosenAdSpot.name}
        </div>
      </div>
    );
  };




  useEffect(() => {
	  
	setFieldsAreModified ( !compareAdsCampaign ( initialAdsCampaign, name, beginningDate, endingDate) )

  }, [name, beginningDate, endingDate]);


  const checkParams = (): boolean => {
	  
	const test1 = name          !== ''
	const test2 = beginningDate !== null
	const test3 = endingDate    !== null
	
    if ( !test1 ) 
	      {
		   setNameMessage ( 'Il manque le nom' )
          }
	 else {
		   setNameMessage ( '' )
	      }
		  
	if ( !test2 )
	      {
	       setBeginningDateMessage ( 'Il manque la date de début' )
		  }
	 else {
	       setBeginningDateMessage ( '' )
	      }
	 
	if ( !test3 )   
	      {
		   setEndingDateMessage    ( 'Il manque la date de fin' )
		  }
     else {	
	       setEndingDateMessage    ( '' )
	      }
		  
 	
   return test1 && test2 && test3 
  }

  const save = async () => {

    if ( checkParams() )
	      {
		   console.log ("checkParams ok")	  
			  
		   setCheckError        (false)
		   setShowErrorMessages (false)
           setProgress          (0);
           setSaved             (false);

           const result = isEditMode
                          ? await updateAdsCampaign ( id                           ,
                                                      reference                    ,
                                                      agentId                      ,
                                                      totalPriceWithoutTax         ,
													  totalPriceWithTax            ,
													  taxRate                      ,
													  legalStructureId             ,
                                                      beginningDate                ,
                                                      endingDate                   ,
                                                      name                         ,
                                                      channelId                    ,
                                                      areaId                       ,
                                                      advertisingSpotsNumberPerDay ,
                                                      spotDuration                 ,
                                                      adSpotId                     ,
													  schedule                     )
                          : await createAdsCampaign ( reference                    ,
                                                      agentId                      ,
                                                      totalPriceWithoutTax         ,
                                                      totalPriceWithTax            ,
                                                      taxRate                      ,
                                                      legalStructureId             ,
                                                      beginningDate                ,
                                                      endingDate                   ,
                                                      name                         ,
                                                      channelId                    ,
                                                      areaId                       ,
                                                      advertisingSpotsNumberPerDay ,
                                                      spotDuration                 ,
                                                      adSpotId                     ,  
                                                      schedule                     )

                if ( result.code === 1 )
                 {
                  const adsCampaignIdToShow = isEditMode ? id : result.payload
                  adsCampaignSheetId = adsCampaignIdToShow
              //  setSalesCampaignSheetId ( salesCampaignIdToShow )
                  setSaved    (true); // On arrête d'afficher la progression
                  setProgress (0)
                  setApiError (false);
		          setFieldsAreModified (false);
 	             }

           else if ( result.code < 1)
                 {
                  setSaved    (true); 
                  setProgress (0)
                  setApiError (true);
                 }
	      }
 	 else {
		   setCheckError (true)
	      }
  }

  const handleReferenceChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
  
    setReference(e.target.value);
  };

  const handleAgentIdChange = (e: React.ChangeEvent<HTMLSelectElement> ) => {
    
	console.log ('handleAgentIdChange', parseInt (e.target.value))
  
  
    setAgentId(parseInt (e.target.value))
  };

  const handleTotalPriceWithoutTaxChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
  
    setTotalPriceWithoutTax(parseInt (e.target.value))
  };

  const handleTaxRateChange = (e: React.ChangeEvent<HTMLSelectElement> ) => {
  
  
	console.log ('handleTaxRateChange', e.target.value)
  
    setTaxRate(e.target.value)
  };

  const handleTotalPriceWithTaxChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
  
    setTotalPriceWithTax(parseInt (e.target.value))
  };

  const handleLegalStructureSelection = (id: number) => {
	  
    setLegalStructureSelection(false);
	
    let choice : LegalStructure = initializedLegalStructure()

    for (let v = 0; v < legalStructures.length; v++) {
      if (legalStructures[v].id === id) {
		 
        choice = legalStructures[v]	
		
        setChoosenLegalStructure (legalStructures[v]);
/*
        const updatedFields = { ...fields, mediaId: medias[v].id, resultImageFile: lastImageFile };
        setFields(updatedFields);

        if (onChange) {
          const updatedSalesAction: SalesAction = { ...initialSalesAction, ...updatedFields };
          onChange(updatedSalesAction);
        }
*/
        break;
      }
    }
	
    setLegalStructureIdMessage ( testLegalStructure ( choice.id ) )
  };

  const handleBeginningDateChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
  
    setBeginningDate ( convertStringToDate (e.target.value , 'dd/MM/yyyy HH:mm') )
	
//	setBeginningDateMessage ( checkDate ( e.target.value))
  }

  const handleEndingDateChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
  
    setEndingDate ( convertStringToDate (e.target.value , 'dd/MM/yyyy HH:mm') )
  }

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
  
    setName(e.target.value);
  };

  const handleChannelIdChange = (e: React.ChangeEvent<HTMLSelectElement> ) => {
  
	console.log ('handleChannelIdChange', parseInt (e.target.value))
  
    setChannelId(parseInt (e.target.value));
  };

  const handleAreaIdChange = (e: React.ChangeEvent<HTMLSelectElement> ) => {

	console.log ('handleAreaIdChange', parseInt (e.target.value))
  
    setAreaId(parseInt (e.target.value))
  };

  const handleAdvertisingSpotsNumberPerDayChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
  
    setAdvertisingSpotsNumberPerDay(parseInt (e.target.value))
  };

  const handleSpotDurationChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
  
    setSpotDuration (parseInt (e.target.value))
  };
 
  const handleAdSpotSelection = (id: number) => {
	  
    setAdSpotSelection(false);
	
/*
    for (let v = 0; v < medias.length; v++) {
      if (medias[v].id === id) {
		 
        choice = medias[v]	
		
        setChoosenMedia (medias[v]);
/*
        const updatedFields = { ...fields, mediaId: medias[v].id, resultImageFile: lastImageFile };
        setFields(updatedFields);

        if (onChange) {
          const updatedSalesAction: SalesAction = { ...initialSalesAction, ...updatedFields };
          onChange(updatedSalesAction);
        }

        break;
      }
    }
*/	
 //   setMediaIdMessage ( testMedia ( choice.id ) )
  };



  const handleSaveButton = () => {

    if ( !saveButtonLock )
     {
      setSaveButtonLock (true)
      save ()
     }
     else {console.log ("LOCK")}
  }

  const handleValidButton2 = () => {

    setSaved (false)
    setProgress (0)
    setSaveButtonLock (false)

    if ( isEditMode )
          {
           if ( onEdit )
            {
             onEdit ( adsCampaignSheetId )
            }
          }
     else {
           if ( onCreate )
            {
             onCreate ( adsCampaignSheetId )
            }
          }
  }


  const handleErrorAckButton = () => {

    setSaved (false)
    setSaveButtonLock (false)
    window.scroll(0, 0);
  }

  const handleCancelButton2 = () => {

    setCancelation (false)
    setSaved (false)
    setSaveButtonLock (false)
    window.scroll(0, 0);
  }

  const handleAdsCampaingCreationAckButton = () => {

    setCancelation (false)

    if ( isEditMode )
          {
           if ( onEdit )
            {
             onEdit ( 0 )
            }
          }
     else {
           if ( onCreate )
            {
             onCreate ( 0 )
            }
          }
  }

  const handleCancelButton3 = () => {

    setCancelation (true)
  }

  const handleCheckErrorAckButton = () => {
	  
	setCheckError (false) 
  }



/*
    const columns = [
      { 
        header       : 'Date', 
        accessor     : 'date' as keyof Schedule, 
//        cellRenderer : (value: any) => (<span onClick={() => handleSpanClick(value)} style={{ textDecoration: 'underline'  , cursor: 'pointer' }}>{value}</span>),
        width        : '50px'
      },
      { 
        header       : 'Heure', 
        accessor     : 'hour' as keyof Schedule, 
      },
      { 
        header       : 'Media', 
        accessor     : 'media' as keyof Schedule, 
      },
      { 
        header       : 'Durée', 
        accessor     : 'duration' as keyof Schedule 
      },
      { 
        header       : 'Chaîne', 
        accessor     : 'channel' as keyof Schedule 
      }
    ];
*/

  return (

           <div className={classNames(styles.root)}>

             {
              checkError &&
              <Window message                 = {<>La fiche comporte des erreurs</>}
                      messageType             = "information"
                      onClickOnValidateButton = {handleCheckErrorAckButton} 
                      validButtonText         = "Ok"					  />
             }

             {
              !saved && (progress > 0) &&
              <Window message     = {<>Les éléments de la fiche sont en cours d'upload<br/>{`${progress}%`} effectués</>}
                      messageType = "information" 
                      validButtonText         = "Ok"										  />
             }

             {
              saved && apiError &&
              <Window message                 = {<>Une erreur est survenue lors de la création de la fiche</>}
                      messageType             = "information"
                      onClickOnValidateButton = {handleErrorAckButton} 
                      validButtonText         = "Ok"					  />
             }

             {
              saved && !apiError &&
              <Window message                 = { isEditMode ? <>Campagne modifiée</> : <>Campagne créée</>}
                      messageType             = "information"
                      onClickOnValidateButton = {handleAdsCampaingCreationAckButton}  
                      validButtonText         = "Ok"    					  />
             }

             {/*
              saved && !error &&
              <Window message                 = {<>Fiche créée<br/>Voulez-vous créer une autre fiche ?</>}
                      messageType             = "question"
                      onClickOnCancelButton   = {handleCancelButton}
                      onClickOnValidateButton = {handleValidButton}  
                      validButtonText         = "Oui"
                      cancelButtonText        = "Non"    					  />
             */}
			 
             {
              cancelation &&
              <Window message                 = {<>Etes-vous sûr de vouloir annuler vos saisies ?</>}
                      messageType             = "question"
                      onClickOnCancelButton   = {handleCancelButton2}
                      onClickOnValidateButton = {handleValidButton2}  
                      validButtonText         = "Oui"
                      cancelButtonText        = "Non"    			  />
             }

             {
              adSpotSelection &&
              <AdSpotSelector adSpotSet    = {adSpotSet}
                          onCancel = {handleAdSpotSelectorHide}
                          onSelect = {handleAdSpotSelection} />
             }

             {
              legalStructureSelection &&
              <LegalStructureSelector legalStructureSet = {legalStructures}
                                      onCancel          = {handleLegalStructureSelectorHide}
                                      onSelect          = {handleLegalStructureSelection} />
             }

             <div className={classNames(styles.contain)}>

                <div className={classNames(styles.form)}>

                 {
				  isEditMode &&
				  <div className={classNames(styles.adsCampaignId)}>
					{`Id : ${id}`}
                  </div>
				 }

                 {
				  isEditMode &&
				  <div className={classNames(styles.creationDate)}>
					{`Date de création : ${convertDateToString (creationDate,'dd/MM/yyyy HH:mm')}`}
                  </div>
				 }

				  <div className={classNames(styles.reference)}>
					<WidgetFrame name               = "Ref commande :"
                                 error              = {referenceMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"
								 classNameGrid      = {classNames(styles.grid_frame2)} >

				      <Field type     = "text" 
					         value    = {reference} 
							 onChange = {handleReferenceChange} />

				    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.agent)}>
					<WidgetFrame name               = "Vendu par :"
                                 error              = {agentIdMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid      = {classNames(styles.grid_frame3)} >

                        <Select choicesLabel  = { [
                                                    "John Doe"
                                                  ] }
                                choices       = { [
                                                    "1",
                                                  ] }												  
                                value         = {`${agentId}`}
                                onChange      = {handleAgentIdChange}    />

				    </WidgetFrame>
                  </div>		

				  <div className={classNames(styles.totalPriceWithoutTax)}>
					<WidgetFrame name               = "Montant HT :"
                                 error              = {totalPriceWithoutTaxMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"
								 classNameGrid      = {classNames(styles.grid_frame3)} >

				      <Field type     = "text" 
					         value    = {totalPriceWithoutTax} 
							 onChange = {handleTotalPriceWithoutTaxChange} />

				    </WidgetFrame>
                  </div>				  
				  
				  <div className={classNames(styles.taxRate)}>
					<WidgetFrame name               = "TVA :"
                                 error              = {taxRateMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"
								 classNameGrid      = {classNames(styles.grid_frame4)} >

                        <Select choices       = { [
                                                    "20%",
													"10%",
													"5.5%",
													"Aucune"
                                                  ] }												  
                                value         = {taxRate}
                                onChange      = {handleTaxRateChange}    />

				    </WidgetFrame>
                  </div>				  

				  <div className={classNames(styles.totalPriceWithTax)}>
					<WidgetFrame name               = "Montant TTC :"
                                 error              = {totalPriceWithTaxMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"
								 classNameGrid      = {classNames(styles.grid_frame3)} >

				      <Field type     = "text" 
					         value    = {totalPriceWithTax} 
							 onChange = {handleTotalPriceWithTaxChange} />

				    </WidgetFrame>
                  </div>				  

                  <div className = {classNames(styles.legalStructure)}>
                    <WidgetFrame name               = "Entreprise :"
                                 error              = {legalStructureIdMessage}
                                 labelTextPosition  = "right"
                                 labelBlockPosition = "left"
                                 classNameGrid      = {classNames(styles.grid_frame2)} >
					{/*
					  <div className={classNames(styles.centeredElements)}>
                        {
                         (choosenLegalStructure.id === 0)
                         ?
                         (
                          <Trigger name="Choisir une entreprise" onClick={handleLegalStructureSelectorShow} variant="tailwind2" />
                         )
                         :
                         (
                          <>
                           {renderChoosenLegalStructure()}
                           <Trigger name="Choisir une autre entreprise" onClick={handleLegalStructureSelectorShow} variant="tailwind2" />
                          </>
                         )
                        }
                      </div>
					*/}
					
					<FieldLegalStructure value    = { choosenLegalStructure ? `${choosenLegalStructure.tradeName} / ${choosenLegalStructure.companyName}` : ''} 
							             onChange = {handleNameChange}
										 legalStructures ={legalStructures} />
                    </WidgetFrame>
                  </div>

				  <div className={classNames(styles.beginningDate)}>
					<WidgetFrame name               = "Date et heure de début :"
                                 error              = {beginningDateMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid={classNames(styles.grid_frame)} >

                      <FieldCalendar value      = {beginningDate ? convertDateToString (beginningDate, 'dd/MM/yyyy HH:mm') : ''}
                                     onChange   = {handleBeginningDateChange}
                                     showHours  = {true}
                                     checkInput = {false}
                                     dateFormat = 'dd/MM/yyyy HH:mm'/>

				    </WidgetFrame>
                  </div>

				  <div className={classNames(styles.endingDate)}>
					<WidgetFrame name               = "Date et heure de fin :"
                                 error              = {endingDateMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid={classNames(styles.grid_frame)} >
									 {/*
                      <Field value      = {endingDate ? convertDateToString (endingDate, 'dd/MM/yyyy HH:mm') : ''}
                             onChange   = {handleEndingDateChange}
                             type       = "calendar_with_hour"
                             dateFormat = 'dd/MM/yyyy HH:mm'/>
									 */}
									 
                      <FieldCalendar value      = {endingDate ? convertDateToString (endingDate, 'dd/MM/yyyy HH:mm') : ''}
                                     onChange   = {handleEndingDateChange}
                                     showHours  = {true}
                                     checkInput = {false}
                                     dateFormat = 'dd/MM/yyyy HH:mm'/>

									 
				    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.name)}>
					<WidgetFrame name               = "Nom de la campagne :"
                                 error              = {nameMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid      = {classNames(styles.grid_frame2)} >

				      <Field type     = "text" 
					         value    = {name} 
							 onChange = {handleNameChange} />

				    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.channel)}>
					<WidgetFrame name               = "Chaîne :"
                                 error              = {channelIdMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid      = {classNames(styles.grid_frame)} >

                        <Select choicesLabel  = { [
                                                    "Lovelight TV"
                                                  ] }
                                choices       = { [
                                                    "1",
                                                  ] }												  
                                value         = {`${channelId}`}
                                onChange      = {handleChannelIdChange}    />

				    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.area)}>
					<WidgetFrame name               = "Zone :"
                                 error              = {areaIdMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid      = {classNames(styles.grid_frame)} >

                        <Select choicesLabel  = { [
                                                    "France",
                                                    "Auvergne-Rhône-Alpes",
                                                    "Bourgogne-Franche-Comté",
                                                    "Bretagne",
                                                    "Centre-Val de Loire",
                                                    "Corse",
                                                    "Grand Est",
                                                    "Hauts-de-France",
                                                    "Île-de-France",
                                                    "Normandie",
                                                    "Nouvelle-Aquitaine",
                                                    "Occitanie",
                                                    "Pays de la Loire",
                                                    "Provence-Alpes-Côte d'Azur",
                                                    "Guadeloupe",
                                                    "Guyane",
                                                    "Martinique",
                                                    "La Réunion",
                                                    "Mayotte",
                                                  ] }
                                choices       = { [
                                                    "1",
                                                    "2",
                                                    "3",
                                                    "4",
                                                    "5",
                                                    "6",
                                                    "7",
                                                    "8",
                                                    "9",
                                                    "10",
                                                    "11",
                                                    "12",
                                                    "13",
                                                    "14",
                                                    "15",
                                                    "16",
                                                    "17",
                                                    "18",
                                                    "19",
                                                  ] }												  
                                value         = {`${areaId}`}
                                onChange      = {handleAreaIdChange}    />

				    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.advertisingSpotsNumberPerDay)}>
					<WidgetFrame name               = "Nombre de spots par jour :"
                                 error              = {advertisingSpotsNumberPerDayMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid      = {classNames(styles.grid_frame2)} >

				      <Field type     = "text" 
					         value    = {advertisingSpotsNumberPerDay} 
							 onChange = {handleAdvertisingSpotsNumberPerDayChange} />

				    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.spotDuration)}>
					<WidgetFrame name               = "Durée du spot :"
                                 error              = {spotDurationMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid      = {classNames(styles.grid_frame2)} >

				      <Field type     = "text" 
					         value    = {spotDuration} 
							 onChange = {handleSpotDurationChange} />

				    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.advertisingSpotsNumber)}>
					<WidgetFrame name               = "Nombre total de spots :"
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid      = {classNames(styles.grid_frame2)} >

				      <Field type     = "text" 
					         readOnly = {true}
					         value    = {advertisingSpotsNumber}  />
							 
				    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.spotPriceWithoutTax)}>
					<WidgetFrame name               = "Coût du spot HT :"
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid      = {classNames(styles.grid_frame2)} >

                      <div className={classNames(styles.infosOneLine)}>
				        <Field type     = "text" 
					           readOnly = {true}
					           value    = {spotPriceWithoutTax}  />
					    <span>&nbsp;€</span>
                      </div>
					  
				    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.spotPriceWithTax)}>
					<WidgetFrame name               = "Coût du spot TTC :"
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid      = {classNames(styles.grid_frame2)} >

                      <div className={classNames(styles.infosOneLine)}>
				        <Field type     = "text" 
					           readOnly = {true}
					           value    = {spotPriceWithTax}  />
					    <span>&nbsp;€</span>
                      </div>

				    </WidgetFrame>
                  </div>

				  
                  <div className={classNames(styles.media)}>
                    <WidgetFrame name               =  <div className={classNames(styles.labelWithShift)}>Spot par défaut :</div>
                                 error              = {mediaIdMessage}
                                 labelTextPosition  = "right"
                                 labelBlockPosition = "left"
                                 classNameGrid      = {classNames(styles.grid_frame)} >
                      <div className={classNames(styles.centeredElements)}>
                        {
                         (choosenAdSpot.id === 0)
                         ?
                         (
                          <Trigger name="Choisir un spot" onClick={handleAdSpotSelectorShow} variant="tailwind2" />
                         )
                         :
                         (
                          <>
                           {renderChoosenAdSpot()}
                           <Trigger name="Choisir un autre spot" onClick={handleAdSpotSelectorShow} variant="tailwind2" />
                          </>
                         )
                        }
                      </div>
                    </WidgetFrame>
                  </div>
		  
                  <div className={classNames(styles.scheduleButton)}>
					<Trigger name="Calculer planning" onClick={handleCancelButton3} variant="tailwind2" />
                  </div>
		  
                  <div className={classNames(styles.schedule, styles.frame)}>
					 <div className={styles.title}>Planning</div>
                  </div>

		  
                  <div className={classNames(styles.buttons)}>
                    <div className={classNames(styles.bloc)}>
  		              <Trigger name="Annuler" onClick={handleCancelButton3} variant="tailwind2" />
                      &nbsp;&nbsp;&nbsp;&nbsp;
  		              <Trigger name={isEditMode?"Enregistrer":"Créer"} onClick={handleSaveButton} variant="tailwind2" />
					  &nbsp;&nbsp;
					  {
					   fieldsAreModified &&
					   ( <p className={classNames(styles.alert)} > N’oubliez pas d’enregistrer vos modifications </p> )
					  }
                    </div>
                  </div>

                </div>
			  </div>
           </div>

         );


};


export default AdsCampaignSheet;
